
import React from 'react';
import { cn } from '@/lib/utils';
import { useMobileSidebarAccordion } from '@/hooks/ui/useMobileSidebarAccordion';
import { SidebarCard } from '@/components/ui/cards';

interface MobileSidebarAccordionProps {
  children: React.ReactNode;
  persistKey?: string;
  defaultExpanded?: boolean;
  className?: string;
  variant?: 'default' | 'blue' | 'purple' | 'amber' | 'green' | 'indigo';
}

const MobileSidebarAccordion: React.FC<MobileSidebarAccordionProps> = ({
  children,
  persistKey,
  defaultExpanded = false,
  className,
  variant = 'purple'
}) => {
  const { isExpanded, toggle, showAccordion } = useMobileSidebarAccordion({
    defaultExpanded,
    persistKey
  });
  
  return (
    <SidebarCard 
      variant={variant}
      isAccordion={showAccordion}
      isExpanded={isExpanded}
      noPadding={showAccordion}
      className={cn("h-full", className)}
    >
      {/* Clone children and inject accordion props into SidebarHeader */}
      {React.Children.map(children, (child, index) => {
        if (React.isValidElement(child) && 
            child.type && 
            typeof child.type !== 'string' && 
            'displayName' in child.type && 
            child.type.displayName === 'SidebarHeader') {
          return React.cloneElement(child as React.ReactElement<any>, {
            isAccordion: showAccordion,
            isExpanded,
            onToggle: toggle,
            showChevron: showAccordion
          });
        }
        
        return child;
      })}
    </SidebarCard>
  );
};

export default MobileSidebarAccordion;
